<script lang="ts">
  import RequiresRetailerUserAuthentication from "@shared/svelte/Components/ProductLines/RequiresRetailerUserAuthentication.svelte";
  import { loginEvent } from "@shared/services/retailer_user_authentication_service";
  import { Button } from "@getprovi/craft-svelte";
  import { OHLQ_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  // export let mobileMode: boolean;
  export let authStatus: string;
  export let authService: any;
</script>

<div class="craft" data-testid="ohlq-cta">
  <RequiresRetailerUserAuthentication retailerUserAuthStatus={authStatus} {authService}>
    <div slot="pending-title"> Want to Order High Proof Spirits & Liquor? </div>

    <div slot="pending-description">
      Connect your Wholesale Cloud Account to shop from your local OHLQ agency store on Provi!
    </div>

    <div slot="pending-buttons">
      <Button on:click={() => authService?.startVerification?.(authStatus)} size="sm"
        >Connect Accounts</Button
      >
    </div>

    <div slot="invalid-description" class="inline text-sm">
      Please call the OHLQ Liquor Enterprise Service Center at <a href="tel:+18778120013"
        >877-812-0013</a
      ><br />
      then verify your account with a new API Key.
    </div>

    <svelte:fragment slot="invalid-buttons">
      <a
        href="https://portal.ohlq.com/My-Account#/account"
        target="_blank"
        rel="noreferrer"
        class="craft-button btn-primary btn-base justify-center"
        style="border-radius: 32px;"
        on:click={() => loginEvent(authStatus, OHLQ_DISTRIBUTOR_ID)}>Log Into WSC</a
      >

      <Button
        variant="secondary"
        on:click={() => authService?.startVerification?.(authStatus)}
        label="Verify Account"
      />
    </svelte:fragment>
  </RequiresRetailerUserAuthentication>
</div>
